module.exports = __webpack_public_path__ + "static/bismillah-bf5f66e9d8d940e316a6f67e508c784b.svg";